<template>
    <div class="form-container active" id="step-3">
        <div class="row justify-content-around">
            <div v-if="user">
                <AppointementSummaryLg :config="config" :prestations="prestations" :start_date="rdv_data.start_date" :location="location"></AppointementSummaryLg>
            </div>
            <div v-else class="col-lg-3">
                <appointment-summary :config="config" :prestations="prestations" :start_date="rdv_data.start_date" :location="location">
                </appointment-summary>
            </div>
            <div class="col-lg-6">
                <!-- <div v-if="this.withAuth == 0 && !get_client_infos">
                    <sign-up :withAuth="withAuth" @sign-in="signup = $event" @submitWithoutAuth="submitClientInfos($event)"></sign-up>
                </div> -->
                <div v-if="!user">
                    <sign-in @userLogin="set_user($event)" @signUp="signup = $event" v-show="!signup"></sign-in>
                    <sign-up :withAuth="withAuth" @sign-in="signup = $event" v-show="signup"></sign-up>
                </div>
                <!-- <div v-else>
                    Confirmation de rendez-vous
                </div> -->
            </div>
        </div>
        <div class="btn-container">
            <button class="btn-secondary1 me-2" id="prevBtn" @click="$emit('back')">Modifier le créneau</button>
            <ConfirmationPopUp v-if="get_client_infos"
                :agenda="agenda"
                :config="config"
                :rdv_data="rdv_data"
                :attendees="getAttendeesFromRdv(rdv)"
                :client_infos="get_client_infos"
                :withAuth="withAuth"
                :autoSelectNext="withAutoSelectNext()"
                :location="location"
                :duration="getDuration"
                :price="getPrice"
                :prestations="prestations"
                :group_size="group_size"
                :prestations_ids="getSelectedPrestationsIds()"
                :start_date="formatDateMoment(start_date, 'DD/MM/YYYY à HH:mm')"
                :fo_config="fo_config">
            </ConfirmationPopUp>
            <!-- <button class=" btn-primary1" id="nextBtn" @click="$emit('submit', null)">Confirmer le rendez-vous</button> -->
        </div> 
    </div>
</template>

<script>
import AppointmentSummary from './AppointmentSummary.vue';
import SignIn from '../Profile/SignIn.vue';
import SignUp from '../Profile/SignUp.vue';
import ConfirmationPopUp from '../SharedComponents/ConfirmationPopUp.vue';
import axios from 'axios';
import moment from 'moment';
import AppointementSummaryLg from './AppointementSummaryLg.vue';
import { Inertia } from '@inertiajs/inertia';


export default {
    name: 'SelectTimeSlot',
    emits: ['back','submit'],
    components: { AppointmentSummary, SignIn, SignUp, ConfirmationPopUp, AppointementSummaryLg},
    props: ['agendas','agenda', 'agenda_id', 'config', 'locations','location','location_id','prestations', 'group_sizes', 'settingsConfig', 'fo_config', 'price', 'rdv_data', 'rdv'],

    data(){
        return {
            signup: false,
            // rdv_data: null,d 
            client_infos: null,
            days: {},
            free_times: [],
            group_size: null,
            is_loading: false,
            show_popup: false,
            time_slot_clicked: false,
            start_date: null,
            logged_user: this.user,
        }
    },

    computed: {
        // get_user() {
        //     console.log('user',this.user);
        //     return this.user;
        // },
        get_client_infos() {
            return this.client_infos
        },
        allow_subgroup () {
            this.prestations[0]?.allow_subgroup
        },
        availableAgendas () {
            if (!this.location_id) return this.agendas
            return this.agendas.filter(agenda => agenda.location_id == this.location_id)
        },
        can_scroll_right () {
            let container = document.querySelector('#free-times-container')
            return container.scrollLeft === 0
        },
        getPrice () {
            if (
                !this.config.display_price
                ||
                this.prestations.find(prestation => !prestation.display_price)
            ) return 'Non communiqué'
            return this.price;
        },
        getDuration () {
            if (
                !this.config.display_duration
                ||
                this.prestations.find(prestation => !prestation.display_duration)
            ) return 'Non communiqué'

            let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
            let hours = Math.floor(duration / 60)
            let minutes = duration % 60
            if (minutes < 10 && minutes != 0) minutes = '0' + minutes
            let str = ''
            if (hours) str += hours + 'h'
            if (minutes) str += minutes + ' minutes'
            return str
        },
        is_prestation_groupe() {
            return this.prestations[0]?.is_group
        },
        max_group_size () {
            return this.prestations[0]?.max_nbr_clients
        },
        no_free_times () {
            return Object.values(this.days).every(day => day.free_times.length === 0)
        },
        user() {
            return this.$page.props.auth.user?.client?.[0]
        },
        theme(){
            return this.fo_config['theme'];
        },
        redirected(){
            return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        withAuth(){
            // console.log(!(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1))
            return !(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        },
    },

    methods: {
        set_user(){
            // Inertia.reload({ only: ["auth.user"] });
            // Inertia.get('/booking')
        },
        getAttendeesFromRdv(rdv){
            if(rdv && rdv.participants){
                for (const participant of rdv.participants) {
                    if (participant.client_id == this.user.client_id) {
                        let attendees = JSON.parse(participant.attendees ?? '[]');
                        return attendees;
                    }
                }
            }
            return null;
        },
        // withAuth(){
        //     console.log(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1)
        //     return !(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        // },
        withAutoSelectNext(){
            return (this.settingsConfig && this.settingsConfig["AUTO_BOOKING"] && this.settingsConfig["AUTO_BOOKING"] == 1);
        },
        formatDate (d) {
            let date = new Date(d)
            let days = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.']
            let months = ['jan.', 'fév.', 'mars.', 'avr.', 'mai.','juin.', 'juil.', 'aout.', 'sept.', 'oct.', 'nov.', 'déc.']
            return days[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + months[date.getUTCMonth()]
        },
        formatDateMoment(date, format) {
            return moment(date).locale('fr').format(format)
        },
        getEmptySlotsNumber (day) {
            let slot_number = []
            for (let day in this.days) {
                slot_number.push(this.days[day]?.free_times?.length || 0)
            }
            const max_number = Math.max(...slot_number)
            return max_number - day.free_times.length
        },
        getSelectedPrestationsString () {
            return this.prestations.map(prestation => prestation.fo_name || prestation.bo_name).join(', ')
        },
        getSelectedPrestationsIds(){
            return this.prestations.map(prestation => prestation.prestation_id);
        },
        getImage() {
            let prestation_with_image = this.prestations.find(prestation => prestation.image)
            if (!prestation_with_image) return false
            return prestation_with_image.image
        },
        getFreeTimes (start_date = null) {
            let prestation_id = this.prestations.map(prestation => prestation.prestation_id).join('/')
            let query = {}
            if (parseInt(this.location_id)) query.location = this.location_id
            if (parseInt(this.agenda_id)) query.agenda = this.agenda_id
            if (this.prestations.find(prestation => prestation.is_group)) {
                query.group_size = this.group_size
            }
            if (start_date) query.from = start_date
            let params = new URLSearchParams(query)

            this.is_loading = true
            let url = `/rdv/slots/with-prestations/${prestation_id}?${params}`
            // Bornage si existe dans le cas de la redirection
            let redirected_params = this.get_redirected_params();
            console.log('redirected_params',redirected_params);
            
            if(redirected_params && redirected_params.min_date && redirected_params.max_date){
                url = url+`&min_date=${redirected_params.min_date}&max_date=${redirected_params.max_date}`;
            }
            return axios.get(url).then(response => {
                let data = response.data
                this.setDays(data)
                this.is_loading = false
            })
        },
        get_redirected_params(){
            if(!this.redirected){
                return null;
            }

            let all_params = new URLSearchParams(window.location.search);
            let params = all_params.get('all_params_redirect');
            if(params != null){
                return JSON.parse(atob(params));
            }
            return null;
        },
        hideModal () {
            this.show_popup = false
            this.start_date = null
            let active_button = document.querySelector('.free_time_button.is-active')
            if (active_button) active_button.classList.remove(('is-active'))
            this.time_slot_clicked = false;
        },
        parseUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('agenda_id') && parseInt(urlParams.get('agenda_id'))) {
                this.agenda_id = urlParams.get('agenda_id')
                this.agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
                if (!this.agenda) return this.$inertia.get('/ressources')
            }
            if (urlParams.get('location_id') && parseInt(urlParams.get('location_id'))) {
                this.location_id = urlParams.get('location_id')
                this.location = this.locations.find(location => location.location_id == this.location_id)
                if (!this.location) return this.$inertia.get('/ressources')
            }
            if (this.prestations.find(prestation => prestation.is_group)) {
                if (this.prestations.length > 1) {
                    toast({
                        message: 'Impossible de combiner les prestations de groupe avec d\'autre prestations.',
                        type: 'is-danger',
                        duration: 4000,
                        pauseOnHover: true
                    })
                    return this.$inertia.get('ressources')
                }
                let prestation = this.prestations[0]
                if (!prestation.allow_subgroup) this.group_size = 1
                else this.group_size = parseInt(urlParams.get('group_size')) || 1
            }
        },
        isEndOfContainer () {
            let container = document.querySelector('#free-times-container')
            return container.scrollLeft >= container.scrollWidth - container.clientWidth - 1
        },
        isFirstDate() {
            let first_date = Object.keys(this.days)[0]
            return !moment().isAfter(first_date, 'day')
        },
        renderLocationAddress(location) {
            if (!location.address) return ''
            let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
            return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
        },
        scrollLeft() {
            let container = document.querySelector('#free-times-container')
            let scroll_level = container.offsetWidth
            container.scrollLeft += scroll_level
            // if (container.scrollLeft > 0) this.can_scroll_right = true
        },
        scrollRight() {
            let container = document.querySelector('#free-times-container')
            let scroll_level = container.offsetWidth
            container.scrollLeft -= scroll_level

            // if (container.scrollLeft === 0) this.can_scroll_right = false

        },
        setDays(data) {
            data.sort((a,b) => (new Date(a.start)).getTime() - (new Date(b.start)).getTime());
            let slotsPerDays = new Map();
            for(let slot of data){
                let d = slot.start.split(' ')[0];
                if(slotsPerDays.has(d)){
                    slotsPerDays.get(d).push(slot)
                }else{
                    slotsPerDays.set(d, [slot]);
                }
            }
            for(let [day,slots] of slotsPerDays.entries()){
                this.days[day] = {
                    date: day,
                    date_string: this.formatDate(day),
                    free_times: slots,
                };
                console.log(data)
                console.log(this.days)
            }
        },
        setStartDate (e, free_time) {
            if(moment(free_time.start).isValid()){
                this.time_slot_clicked = true;
                let active_button = document.querySelector('.free_time_button.is-active')
                if (active_button) active_button.classList.remove(('is-active'))
                e.target.classList.add('is-active')
                this.start_date = free_time.start

                this.agenda_id = free_time.agenda_id
                this.agenda = this.agendas.find(agenda => agenda.agenda_id == free_time.agenda_id)
                this.location = this.locations.find(location => location.location_id == this.agenda.location_id)

                if(!this.rdv_data){
                    this.rdv_data = {}
                }else{
                    this.rdv_data.current_client = this.user;
                }
                this.rdv_data.day  = moment(this.start_date).format('YYYY-MM-DD');
                this.rdv_data.heure  = moment(this.start_date).format('HH:mm');
                this.rdv_data.start_date = this.start_date;
                let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
                this.rdv_data.end_date = moment(this.start_date).add(duration, 'minutes').format('YYYY-MM-DD HH:mm');
                this.rdv_data.group_size  = this.group_size;
                this.rdv_data.idAgenda  = this.agenda_id;
                this.rdv_data.idPrestation  = this.prestations.map(prestation => prestation.prestation_id).toString();
                this.rdv_data.location_id  = this.location_id;

                // console.log(this.rdv_data);
                

                if (this.user) this.show_popup = true
                else this.toggleAuthModal()
            }else{
                toast({
                    message: "Date invalide: Il y a un problème avec le créneau choisi",
                    type: 'is-danger',
                    duration: 5000,
                    pauseOnHover: true
                })
            }
        },
        switchNext () {
            let container = document.querySelector('#free-times-container')
            if (container.scrollLeft + container.offsetWidth >  container.scrollWidth - container.clientWidth){
                this.loadNext().then(()=>this.$nextTick()).then(()=>this.scrollLeft())
            }else{
                this.scrollLeft()
            }

        },
        loadNext(){
            let last_date = Object.keys(this.days).pop()
            let start_date = moment(last_date).add(1, 'days').format('YYYY-MM-DD')
            return this.getFreeTimes(start_date)
        },
        onFreesTimeScroll(){
            if(this.isEndOfContainer()){
                this.loadNext();
            }
        },
        toggleAuthModal () {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        submitClientInfos(data){
            // console.log("submitClientInfos");
            
            this.client_infos = data;
            this.show_popup = true;
            console.log(this.submitClientInfos, data)
        },

    },
    mounted () {
        this.parseUrl();

        // Initialisation du token et authentification de l'utilisateur
        if(this.fo_config['redirected'] == 1){
            let token = (new URLSearchParams(location.search)).get('token');
            if(token){
                axios.post('/redirect/auth/login', {
                    token: token
                })
                .then(response => {
                    this.form_error = null;
                    let user = response.data.client;
                    this.$emit('userLogin', user);
                    Inertia.reload({ only: ["auth.user"] });
                })
                .catch(err => {
                    this.form_error = err?.response?.data?.message ?? 'Une erreur est survenue'
                })   
            }
        }

        if (this.location_id) {
            this.location = this.locations.find(location => location.location_id == this.location_id)
            if (!this.location) return this.$inertia.get('/ressources')
        } else if (this.agenda_id) {
            this.agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
            this.location = this.locations.find(location => location.location_id == this.agenda.location_id)
            if (!this.agenda || !this.location) return this.$inertia.get('/ressources')
        }
        this.getFreeTimes().then(()=>{
            // Si La réservation automatique est activée, sélectionner le premier créneau
            if(this.settingsConfig["AUTO_BOOKING"] == 1 ?? null){
                let keys = Object.keys(this.days);
                if(keys.length > 0){
                    this.$refs.free_time_00.click();
                }
            }
        });
        // En cas de modification initialiser le rdv
        this.rdv_data = this.rdv;
        // if(this.rdv_data.rdv_id){
        //     this.rdv_data.participants = this.getAttendeesFromRdv(this.rdv_data);
        // }
        // console.log("confirmationrdv rdv",this.rdv,this.rdv_data);
    },
    watch: {
        user(value) {
            if (value && this.rdv_data && this.time_slot_clicked) this.show_popup = true;
        }
    },

    mounted(){
        console.log('Validate appointment',this.rdv_data);
    }
}

</script>